import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    fa: "۰۱",
    title: "ضمانت اصالت عیار ۹۰۰",
    text: "هر قطعه سکه با عیار ۹۰۰ و وزن دقیق استاندارد عرضه می‌شود. اصالت کالا، دقت در وزن‌کشی و شفافیت نرخ، خط قرمز ماست.",
    testid: "manifesto-chapter-1",
  },
  {
    n: "02",
    fa: "۰۲",
    title: "پلمپ رسمی و هولوگرام امنیتی",
    text: "سکه‌ها با پلمپ معتبر و هولوگرام امنیتی تحویل داده می‌شوند؛ فعالیت مجموعه با مجوز رسمی اتحادیه طلا، جواهر و نقره تهران انجام می‌شود.",
    testid: "manifesto-chapter-2",
  },
  {
    n: "03",
    fa: "۰۳",
    title: "نرخ‌گذاری شفاف",
    text: "نرخ تابلو بر مبنای نرخ روز اتحادیه و بازار، هر روز صبح به‌صورت شفاف اعلام می‌شود؛ نرخ نهایی هنگام معامله در مغازه قطعی می‌شود.",
    testid: "manifesto-chapter-3",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative mx-auto max-w-7xl scroll-mt-28 px-4 py-24 sm:px-6 lg:px-12">
    <div className="absolute right-1/2 top-0 h-72 w-72 translate-x-1/2 rounded-full bg-amber-500/8 blur-[110px]" />
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="relative mb-14 text-center"
    >
      <span className="text-xs tracking-widest text-amber-500/70">منشور کازرانی</span>
      <h2 className="mx-auto mt-3 max-w-xl text-base font-bold leading-8 text-amber-100 md:text-lg">
        سه اصلی که از روز اول کنار آن ایستاده‌ایم
      </h2>
    </motion.div>
    <div className="relative grid grid-cols-1 gap-6 md:grid-cols-3">
      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.n}
          data-testid={c.testid}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.75, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="gold-sheen glass group rounded-2xl border-r-2 border-r-amber-500/50 p-7 transition-colors duration-300 hover:border-amber-500/45"
        >
          <div className="font-display text-5xl font-black text-amber-500/25 transition-colors duration-500 group-hover:text-amber-500/50">
            {c.n}
          </div>
          <h3 className="mt-4 text-lg font-bold text-amber-200">{c.title}</h3>
          <p className="mt-3 text-sm font-light leading-7 text-stone-400">{c.text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
